//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get, sync } from 'vuex-pathify';
import { mdRender } from "../../functions/remarkable";
export default {
  name: 'ThankYou',
  computed: {
    bgImage: function bgImage() {
      return this.$store.getters['theme/bgImage'];
    },
    logo: get('theme/theme@logoColor'),
    loggedInMember: sync('settings/loggedInMember'),
    logoRestaurant: get('theme/logo')
  },
  methods: {
    restartSurvey: function restartSurvey() {
      this.loggedInMember = null;
      this.$router.push('/staff');
    },
    renderText: function renderText(text) {
      return mdRender(text);
    }
  }
};